import StoreLink from './StoreLink'
export default StoreLink
